import { jsxs as e, Fragment as l, jsx as C } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ e(l, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M18.3783 15.4257C18.8895 15.2168 19.1346 14.6329 18.9257 14.1217C18.7168 13.6105 18.1329 13.3654 17.6217 13.5743C15.2912 14.5267 13.5754 14.966 11.9302 14.9684C10.2897 14.9707 8.62373 14.5386 6.39465 13.5812C5.8872 13.3632 5.29913 13.5979 5.08117 14.1053C4.86321 14.6128 5.09789 15.2009 5.60535 15.4188C7.95895 16.4297 9.91044 16.9713 11.933 16.9684C13.9509 16.9655 15.9437 16.4207 18.3783 15.4257Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M13.5645 2.45965C12.6171 1.84678 11.3829 1.84678 10.4355 2.45965L3.19592 8.25363C2.44878 8.73695 2 9.55061 2 10.4219V19.2632C2 20.7747 3.26279 22 4.82051 22H19.1795C20.7372 22 22 20.7747 22 19.2632L22 10.4219C22 9.55061 21.5512 8.73695 20.8041 8.25363L13.5645 2.45965ZM12.4169 4.10285L19.6331 9.87813L19.7178 9.9329C19.9099 10.0572 20 10.2464 20 10.4219L20 19.2632C20 19.6138 19.6899 20 19.1795 20H4.82051C4.31014 20 4 19.6138 4 19.2632V10.4219C4 10.2464 4.0901 10.0572 4.28222 9.9329L4.36689 9.87813L11.5831 4.10285C11.8403 3.96572 12.1597 3.96572 12.4169 4.10285Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  )
] });
export {
  t as default
};
